const defaultState = {
  isConnected: false
};

const state = Object.assign({}, defaultState);

const mutations = {
  RESET_FIREBASE_STATE(state) {
    Object.assign(state, defaultState);
  },
  CHANGE_FIREBASE_STATE(state, isConnected) {
    state.isConnected = isConnected;
  }
};

const actions = {
  resetFirebaseState: ({ commit }) => {
    commit('RESET_FIREBASE_STATE');
  },
  changeFirebaseState: ({ commit }, isConnected) => {
    commit('CHANGE_FIREBASE_STATE', isConnected);
  }
};

export default {
  state,
  mutations,
  actions
};
